import React from 'react';
import { useState, useEffect } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup, MenuItem, Select, Button, TextField, Grid, InputLabel } from '@mui/material';
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


function VendorPurchaseReport() {
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [vendors, setVendors] = useState([]); //nabil 
    const [items, setItems] = useState([]); //nabil
    const [apiErrors, setApiErrors] = useState([]); //nabil
    const [selectedOption, setSelectedOption] = React.useState('all');
    const [selectedClass, setSelectedClass] = React.useState('');
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = React.useState('');
    const [ddlClass, setDdlClass] = useState([]);
    const [schoolData, setSchoolData] = useState([]);
    const [reportData, setReportData] = useState(null);


    // Nabil is adding new code from here




    const [formData, setFormData] = useState({
        branchID: "",
        categoryID: "",
        itemName: "",
        itemCode: "",
        purchasedPrice: "",
        currentBalance: "",
        purchaseDate: null,
        vendorID: "",
        vendorName: "",
        taxId: null,
        locationID: "",
        isDepreciable: false,
        usefulLifeYears: "",
        currentValue: "0",
        isAutoGenerateItemCode: true,
    });

    const addApiError = (errorMessage) => {
        setApiErrors((prev) => [...prev, errorMessage]);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        console.log(`Field changed: ${name}, Value: ${value}, Type: ${type}`);
        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : name === "taxId"
                        ? value === ""
                            ? null
                            : parseInt(value)
                        : value,
            ...(name === "isDepreciable" && !checked ? { usefulLifeYears: "" } : {}),
        }));

    };

    const fetchItems = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem("token");

            const response = await fetch(`${apiUrl}/inventory/Items/GetAllItems`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({}),
            });

            if (response.ok) {
                const data = await response.json();
                if (Array.isArray(data)) {
                    setItems(data);
                } else {
                    addApiError("Invalid item data received.");
                }
            } else {
                addApiError("Failed to fetch items.");
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            addApiError(`Error fetching items: ${error.message}`);
        }
    };

    const fetchSchoolDetails = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem('token');
            const response = await fetch(`${apiUrl}/FeeReport/GetSchoolName`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({}),
            });
            if (!response.ok) {
                throw new Error(`Error fetching financial years: ${response.status}`);
            }
            const data = await response.json();
            setSchoolData(data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchVendors = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${apiUrl}/inventory/Vendor/GetVendors`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({}),
            });

            if (response.ok) {
                const data = await response.json();
                console.log("Vendors fetched:", data);
                if (Array.isArray(data.vendors)) {
                    setVendors(data.vendors);
                } else {
                    addApiError("Invalid vendor data received.");
                }
            } else {
                addApiError("Failed to fetch vendors.");
            }
        } catch (error) {
            console.error("Error fetching vendors:", error);
            addApiError(`Error fetching vendors: ${error.message}`);
        }

    };




    // Nabil added new code till here






    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleClassChange = (event) => {
        setSelectedClass(event.target.value);
    };

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleClear = () => {
        setFormData({
            ...formData,
            vendorID: "",
        });
        setFromDate("");
        setToDate("");
        setReportData(null); // Clear report data if needed

    };

    const formatDate = (dateString) => {
        const parts = dateString.split('-'); // [YYYY, MM, DD]
        return `${parts[0]}/${parts[1]}/${parts[2]}`;
    };


    const getBase64FromImageUrl = async (imageUrl) => {
        const res = await fetch(imageUrl);
        const blob = await res.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };


    const handleSave = async () => {
        try {
            const url = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem("token");

            const queryParams = new URLSearchParams({
                vendorId: formData.vendorID === "0" ? "" : formData.vendorID || "",
                startDate: fromDate ? formatDate(fromDate) : "",
                endDate: toDate ? formatDate(toDate) : "",
                format: "json",
            });

            const apiUrl = `${url}/InventoryReport/VendorPurchaseReport?${queryParams.toString()}`;

            const response = await fetch(apiUrl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Response error text:", errorText);
                // alert("Error fetching Vendor Purchase Report");
                setSnackbarMessage('Error fetching Vendor Purchase Report!');
                setOpenSnackbar(true);
                return;
            }

            const data = await response.json();

            if (data.msg === "Record Not Found") {
                // alert("No records found");
                setSnackbarMessage('No records found!');
                setOpenSnackbar(true);
                return;
            }

            setReportData(data);

            // ✅ Fetch branch/school info
            const branchResponse = await fetch(`${url}/Branch/GetBranch`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({}),
            });

            const branchData = await branchResponse.json();
            const school = Array.isArray(branchData) && branchData.length > 0 ? branchData[0] : {};

            // ✅ Setup PDF
            const doc = new jsPDF("p", "mm", "a4");
            const pageWidth = doc.internal.pageSize.getWidth();
            const contentWidth = pageWidth - 20;
            let margin = 10;
            let yPos = margin + 5;

            const logoBase64 = school.bytLogo
                ? `data:image/jpeg;base64,${school.bytLogo}`
                : null;

            let logoHeight = 0;

            if (logoBase64) {
                try {
                    const logoWidth = 30;
                    const imgProps = doc.getImageProperties(logoBase64);
                    const aspectRatio = imgProps.width / imgProps.height;
                    logoHeight = logoWidth / aspectRatio;
                    doc.addImage(logoBase64, "JPEG", margin + 5, yPos, logoWidth, logoHeight);
                } catch (error) {
                    console.error("Error adding logo:", error);
                    doc.setFontSize(8);
                    doc.text("[Logo Error]", margin + 5, yPos + 12);
                    logoHeight = 12;
                }
            } else {
                doc.setFontSize(8);
                doc.text("[Logo Unavailable]", margin + 5, yPos + 12);
                logoHeight = 12;
            }

            const schoolNameLines = doc.splitTextToSize(
                school.organisationName || "School Name",
                contentWidth - 35
            );
            const addressLines = doc.splitTextToSize(
                `Address: ${school.branchAddress || "Not Available"}`,
                contentWidth - 40
            );

            const headerHeight = Math.max(
                logoHeight,
                5 + addressLines.length * 4 + 16
            );
            const verticalOffset = logoHeight > 0 ? logoHeight / 4 : 5;

            doc.setFont("helvetica", "bold");
            doc.setFontSize(25);
            doc.text(schoolNameLines, margin + 40, yPos + verticalOffset + 2);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(13);
            doc.text(addressLines, margin + 40, yPos + verticalOffset + 9);

            yPos += headerHeight + 4;

            // ✅ Line
            doc.setDrawColor(0);
            doc.setLineWidth(0.5);
            doc.line(margin, yPos, pageWidth - margin, yPos);
            yPos += 5;

            // ✅ Date + Title
            const formattedFromDate = fromDate ? formatDate(fromDate, "dd/MM/yyyy") : "N/A";
            const formattedToDate = toDate ? formatDate(toDate, "dd/MM/yyyy") : "N/A";
            const dateRangeText =
                fromDate && toDate
                    ? `(${formattedFromDate} - ${formattedToDate})`
                    : "(All Records)";

            doc.setFontSize(14);
            doc.setFont("helvetica", "bold");
            doc.text("Vendor Purchase Report", pageWidth / 2, yPos + 10, { align: "center" });

            doc.setFontSize(12);
            doc.text(dateRangeText, pageWidth / 2, yPos + 16, { align: "center" });

            yPos += 22;

            // ✅ Table
            const tableBody = data.map((item) => [
                item.vendorName || "-",
                item.itemCode || "-",
                item.itemName || "-",
                item.purchasedPrice?.toFixed(2) || "0.00",
                item.purchaseDate || "-",
                item.currentBalance || 0,
            ]);

            doc.autoTable({
                startY: yPos,
                head: [[
                    "Vendor Name",
                    "Item Code",
                    "Item Name",
                    "Purchased Price",
                    "Purchase Date",
                    "Current Balance"
                ]],
                body: tableBody,
                theme: "grid",
                styles: {
                    fontSize: 9,
                    cellPadding: 3,
                    overflow: "linebreak",
                    halign: "left",
                    valign: "middle",
                },
                columnStyles: {
                    3: { halign: "right" }, // Purchased Price
                    5: { halign: "right" }, // Current Balance
                },
                headStyles: {
                    fillColor: [217, 228, 232],
                    textColor: [0, 0, 0],
                    fontSize: 10,
                    fontStyle: "bold",
                    halign: "center",
                },
                margin: { left: 10, right: 10 },
            });

            // ✅ Open PDF
            const blob = doc.output("blob");
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, "_blank");

        } catch (error) {
            console.error("Error generating report:", error);
            // alert(`Report generation failed: ${error.message}`);
            // alert(`No Record Found! Try another date`);
            setSnackbarMessage('No Record Found! Try another date!');
                setOpenSnackbar(true);
            
        }
    };


    const generateCSV = () => {
        if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
            console.error('No report data available');
            return;
        }

        let csvContent = '';
        const keys = Object.keys(reportData[0]);
        csvContent += keys.map(key => key.toUpperCase()).join(',') + '\n';
        reportData.forEach(item => {
            const values = keys.map(key => item[key]);
            csvContent += values.join(',') + '\n';
        });
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, 'report.csv');
    };

    const buttonStyles = {
        generate: {
            background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
            borderRadius: "25px",
            padding: "10px 25px",
            width: "150px",
            boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
            transition: "all 0.3s ease",
            "&:hover": {
                background: "linear-gradient(45deg, #1976D2 30%, #1E88E5 90%)",
                transform: "translateY(-2px)",
                boxShadow: "0 5px 10px rgba(33, 203, 243, .4)",
            },
        },
        csv: {
            background: "linear-gradient(45deg, #f44336 30%, #ef5350 90%)",
            borderRadius: "25px",
            padding: "10px 25px",
            width: "150px",
            boxShadow: "0 3px 5px 2px rgba(244, 67, 54, .3)",
            transition: "all 0.3s ease",
            "&:hover": {
                background: "linear-gradient(45deg, #d32f2f 30%, #e53935 90%)",
                transform: "translateY(-2px)",
                boxShadow: "0 5px 10px rgba(244, 67, 54, .4)",
            },
        },
    };

    const selectStyles = {
        width: "250px",
        background: "linear-gradient(45deg, #ffffff 30%, #f5f5f5 90%)",
        borderRadius: "15px",
        boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2196F3",
            borderWidth: "2px",
        },
        "&:hover": {
            boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
            transform: "translateY(-2px)",
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#1976D2",
            },
        },
        "&.Mui-focused": {
            boxShadow: "0 6px 12px rgba(33, 150, 243, 0.3)",
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#21CBF3",
            },
        },
        "& .MuiSelect-select": {
            padding: "12px 16px",
            fontWeight: 500,
            color: "#333",
        },
    };

    // Function to format date to YYYY-MM-DD
    const getFormattedDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Set default dates
    useEffect(() => {
        const today = new Date(); // Current date: March 29, 2025
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(today.getMonth() - 1); // Subtract 1 month

        setToDate(getFormattedDate(today)); // Default "To Date" to today
        setFromDate(getFormattedDate(oneMonthAgo)); // Default "From Date" to one month ago
        // Fetch data

        fetchItems();
        fetchSchoolDetails();
        fetchVendors();

    }, []);

    return (
        <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ margin: '0 auto', maxWidth: '600px' }} // reduced width for better centering
        >
            {/* Category Dropdown - Full width */}
            <Grid item xs={12}>
                <Grid container spacing={2}>


                    {/* Select Vendor */}
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Select Vendor</InputLabel>
                            <Select
                                name="vendorID"
                                value={formData.vendorID}
                                onChange={handleChange}
                                label="Select Vendor"
                                sx={selectStyles}
                            >
                                <MenuItem value="0">All Vendors</MenuItem>
                                {/* ✅ Show actual categories if available */}
                                {vendors.length > 0 ? (
                                    vendors.map((vendor) => (
                                        <MenuItem
                                            key={vendor.vendorID}
                                            value={vendor.vendorID.toString()}
                                        >
                                            {vendor.vendorName}
                                        </MenuItem>
                                    ))
                                ) : (
                                    <MenuItem value="" disabled>No Vendor available</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>





            {/* Date Fields - Side by Side */}
            <Grid item xs={12} sm={6}>
                <TextField
                    label="From Date"
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{ ...selectStyles }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="To Date"
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{ ...selectStyles }}
                />
            </Grid>

            {/* Buttons - Side by Side */}
            <Grid item xs={12} sm={6}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    fullWidth
                    size="medium"
                    sx={{ ...buttonStyles.generate }}
                >
                    Generate Report
                </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Button
                    variant="contained"
                    color="error"
                    onClick={generateCSV}
                    fullWidth
                    size="medium"
                    sx={{ ...buttonStyles.csv }}
                >
                    Download CSV
                </Button>
            </Grid>

            <Grid item xs={12}>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClear}
                    fullWidth
                    size="medium"
                    sx={{
                        borderRadius: "25px",
                        padding: "10px 25px",
                        width: "150px",
                        marginTop: "10px",
                        borderColor: "#6c757d",
                        color: "#6c757d",
                        transition: "all 0.3s ease",
                        "&:hover": {
                            backgroundColor: "#f0f0f0",
                            transform: "translateY(-2px)",
                            borderColor: "#5a6268",
                            color: "#5a6268",
                        },
                    }}
                >
                    Clear Fields
                </Button>
            </Grid>
            <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity="error" sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

        </Grid>

    );
}

export default VendorPurchaseReport;
